import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";

// core components
import HeaderLinks from "./HeaderLinks";
import Button from "../CustomButtons/Button.jsx";

import headerStyle from "../../assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";

function Header({ ...props }) {
  const { classes, color } = props;
  const appBarClasses = cx({
    [" " + classes[color]]: color
  });

  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        {/*Hamburger Menu*/}
        <Hidden mdUp implementation="css">
          <Button
            className={classes.appResponsive}
            color="transparent"
            justIcon
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </Button>
        </Hidden>

        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button href="#" className={classes.title} color="transparent">
          </Button>
        </div>

        <HeaderLinks
          rtlActive={false}
          authStore={props.authStore}
          userAvatarUrl={props.userAvatarUrl}
          headerMainText={props.headerMainText}
          headerSubText={props.headerSubText}
          showTenants={props.showTenants}
        >
          {props.children}
        </HeaderLinks>

      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool,
  authStore: PropTypes.object.isRequired,
  userAvatarUrl: PropTypes.string.isRequired,
  headerMainText: PropTypes.string.isRequired,
  headerSubText: PropTypes.string.isRequired,
  showTenants: PropTypes.bool.isRequired,
};

Header.defaultProps = {
  showTenants: true
};

export default withStyles(headerStyle)(Header);
